import { RepositoryFactory } from '@/api/RepositoryFactory'
import axios from 'axios'

const Bids = RepositoryFactory.get('bids')
const LoadDay = RepositoryFactory.get('loadDay')

export default {
  namespaced: true,
  state: {
    bid: {},
    bids: [],
    error: false,
    pagination: {},
    calculator: {},
    loadingBid: false,
    loadingDay: false,
    loadingMap: false,
    loadingCalc: false,
    loadingModal: false,
    loadingLoadDays: [],
    typeCode: JSON.parse(localStorage.getItem('type_code')) || '',
    typeView: JSON.parse(localStorage.getItem('type_view')) || false,
    unloadPointCityId: [],
    unloadPointKladrId:
      JSON.parse(localStorage.getItem('unload_point_kladr_id')) || [],
    bidsKladrs: null,
    bidIdLanding: null,
  },
  getters: {
    getBid: state => state.bid,
    getBids: state => state.bids,
    isError: state => state.error,
    getPagination: state => state.pagination,
    calculator: state => state.calculator,
    getLoading: state => type => state[`loading${type}`],
    isDayLoading: state => id => state.loadingLoadDays.includes(id),
    getTypeCode: state => state.typeCode,
    getTypeView: state => state.typeView,
    getUnloadPointCityId: state => state.unloadPointCityId,
    getUnloadPointKladrId: state => state.unloadPointKladrId,
    getBidsKladrs: state => state.bidsKladrs,
    getBidIdLanding: state => state.bidIdLanding,
  },
  actions: {
    fetchHome(
      { commit, getters },
      { user_type = 1, isLoad, callback = () => {}, ...requestData },
    ) {
      commit('loadingStart', 'Bid')
      const isDriver = user_type === 4

      if (getters.getBidIdLanding) {
        requestData.bid_id = getters.getBidIdLanding
      }

      return Bids.getHome(requestData, isDriver)
        .then(res => {
          commit('setError', false)
          commit('updateBids', { data: res.data, isLoad })
          callback()
        })
        .catch(error =>
          axios.isCancel(error)
            ? commit('loadingStart', 'Bid')
            : commit('setError', true),
        )
        .finally(() => commit('loadingStop', 'Bid'))
    },
    fetchHomeBid({ commit }, { bid_id, user_type }) {
      commit('loadingStart', 'Day')
      const isDriver = user_type === 4

      return Bids.getHomeBid({ bid_id }, isDriver)
        .then(res => commit('updateHomeBid', { bid_id, data: res.data }))
        .catch(e => console.log(`[fetchHomeBid] err: `, e))
        .finally(() => commit('loadingStop', 'Day'))
    },
    fetchBidsKladrs({ commit }) {
      commit('loadingStart', 'Day')

      return Bids.getBidsKladrs()
        .then(res => commit('updateBidsKladrs', { data: res.data }))
        .catch(e => console.log(`[fetchBidsKladrs] err: `, e))
        .finally(() => commit('loadingStop', 'Day'))
    },
    fetchBidForMap({ commit }, id) {
      commit('loadingStart', 'Map')

      return Bids.getBid(id)
        .then(res => commit('updateBid', res.data))
        .catch(e => console.log(`[fetchBidForMap] err: `, e))
        .finally(() => commit('loadingStop', 'Map'))
    },
    fetchPromoBids({ commit }) {
      commit('loadingStart', 'Bid')

      return Bids.getPromoBids()
        .then(res => commit('updateBidsInfo', res.data.items))
        .catch(e => console.log(`[fetchPromoBids] err: `, e))
        .finally(() => commit('loadingStop', 'Bid'))
    },
    fetchCalcResults({ commit }, data) {
      commit('loadingStart', 'Calc')

      return Bids.calculate(data)
        .then(res => commit('updateCalc', res.data))
        .catch(e => console.log(`[fetchCalcResults] err: `, e))
        .finally(() => commit('loadingStop', 'Calc'))
    },
    createBidsDay(
      { commit, dispatch },
      { bid_id, data, user_type, callback = () => {} },
    ) {
      commit('loadingStart', 'Modal')

      return LoadDay.postLoadDay({ ...data, bid_id })
        .then(({ status }) => {
          dispatch('fetchHomeBid', { bid_id, user_type })
          callback(status === 200)
        })
        .catch(e => console.log(`[createBidsDay] err: `, e))
        .finally(() => commit('loadingStop', 'Modal'))
    },
    updateDayFields({ commit }, { id, data, callback = () => {} }) {
      commit('loadingStart', 'Modal')
      let method = 'putLoadDay'

      if (data?.status === 1) {
        method = 'closeLoadDay'
      }

      return LoadDay[method](id, data)
        .then(({ status, data: day }) => {
          commit('updateBidsDay', { day, fields: data })
          callback(status === 200)
        })
        .catch(e => console.log(`[deleteBidsDay] err: `, e))
        .finally(() => commit('loadingStop', 'Modal'))
    },
    deleteBidsDay({ commit }, { id, bid_id, callback = () => {} }) {
      commit('loadingStart', 'Modal')

      return LoadDay.deleteItem(id)
        .then(() => {
          commit('removeBidsDay', { id, bid_id })
          callback()
        })
        .catch(e => console.log(`[deleteBidsDay] err: `, e))
        .finally(() => commit('loadingStop', 'Modal'))
    },
  },
  mutations: {
    clearBids(state) {
      state.pagination = {}
      state.bids = []
    },
    updateBids(state, { data, isLoad }) {
      const { items, _meta } = data

      state.pagination = _meta
      state.bids = isLoad ? [...state.bids, ...items] : items
    },
    updateTypeView(state) {
      localStorage.setItem('type_view', JSON.stringify(!state.typeView))
      state.typeView = !state.typeView
    },
    initTypeView(state) {
      state.typeView = true
      localStorage.setItem('type_view', JSON.stringify(state.typeView))
    },
    updateUnloadPointCityId(state, data) {
      state.unloadPointCityId = data
    },
    updateUnloadPointKladrId(state, data) {
      localStorage.setItem('unload_point_kladr_id', JSON.stringify(data))
      state.unloadPointKladrId = data
    },
    updateTypeCode(state, data) {
      localStorage.setItem('type_code', JSON.stringify(data))
      state.typeCode = data
    },
    setError(state, bool) {
      state.error = Boolean(bool)
    },
    updateBid(state, data) {
      state.bid = data
    },
    updateBidsKladrs(state, data) {
      state.bidsKladrs = data.data
    },
    updateHomeBid(state, { bid_id, data }) {
      if (data && data.items && data.items.length) {
        const bid = state.bids.find(item => item.id === bid_id)

        if (bid) {
          bid.load_days = data.items[0].load_days
        }
      }
    },
    updateBidData(state, obj) {
      const index = state.bids.findIndex(item => item.id === obj.id)

      if (index > -1) {
        const bid = { ...state.bids[index], ...obj.data }

        state.bids.splice(index, 1, bid)
      }
    },
    updateBidsInfo(state, bids) {
      state.bids = bids
    },
    updateCalc(state, res) {
      state.calculator = res
    },
    addBidsDay(state, { data, bid_id }) {
      const item = state.bids.find(item => item.id === bid_id)

      if (!data.responses) {
        data.responses = []
      }
      if (item) {
        item.load_days.push(data)
      }
    },
    updateBidsDay(state, { day, fields }) {
      const bid = state.bids.find(b => b.id === day.bid_id)

      if (bid?.load_days) {
        const index = bid.load_days.findIndex(d => d.id === day.id)

        if (index > -1) {
          bid.load_days.splice(index, 1, { ...bid.load_days[index], ...fields })
        }
      }
    },
    removeBidsDay(state, { id, bid_id }) {
      const bid = state.bids.find(item => item.id === bid_id)

      if (bid) {
        bid.load_days = bid.load_days?.filter(d => d.id !== id) || []
      }
    },
    loadingStart(state, type) {
      state[`loading${type}`] = true
    },
    loadingStop(state, type) {
      state[`loading${type}`] = false
    },
    loadingDay(state, payload) {
      if (payload.status === 'start') {
        state.loadingLoadDays.push(payload.id)
      } else {
        state.loadingLoadDays = state.loadingLoadDays.filter(
          c => c !== payload.id,
        )
      }
    },
    setBidIdLanding(state, payload) {
      state.bidIdLanding = payload
    },
  },
}
